const isString = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'String'
}

const isNumber = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'Number'
}

const isBoolean = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'Boolean'
}

const isObj = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'Object'
}

const isArray = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'Array'
}

const isDate = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'Date'
}

const isNull = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'Null'
}

const isUndefined = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'Undefined'
}

const isNullOrUndefined = function(o) {
  return isNull(o) || isUndefined(o)
}

const isBlob = function(o) {
  return Object.prototype.toString.call(o).slice(8, -
    1) === 'Blob'
}

const isEmptyDict = function(o) {
  return JSON.stringify(o) == '{}'
}

const isEmptyArray = function(o) {
  return o.length === 0
}

export {
  isString,
  isNumber,
  isBoolean,
  isObj,
  isArray,
  isDate,
  isNull,
  isUndefined,
  isNullOrUndefined,
  isBlob,
  isEmptyDict,
  isEmptyArray
}


// WEBPACK FOOTER //
// ./src/utils/typeUtils.js